var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalifornia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.722,235.811c-4.872-3.159-2.501-4.214-3.159-6.188c-0.66-1.974-3.292-6.978-3.292-6.978l0.965-3.51l-9.981-14.859 l-66.202-98.539l19.271-69.068l0,0c-32.937-8.86-68.266-19.093-71.513-20.034l-2.218,3.528v9.61c0,0-4.739,10.927-5.397,11.718 c-0.659,0.789-5.268,4.74-5.268,4.74l-2.632,8.821c2.632,4.869,6.055,15.535,5.529,17.903c-0.528,2.371-2.238,4.345-2.238,4.345 l-1.185,10.27l7.898,18.167v6.187l5.793,7.11l-1.843,16.589l2.897,15.271c-0.79,4.477,15.534,37.258,15.929,38.706 c0.396,1.449-2.632,14.351-1.711,15.932c0.922,1.578,18.037,5.791,18.037,5.791s6.451,10.271,6.846,11.322 c0.396,1.054,10.005,2.897,10.005,2.897c0.527,0.79,6.19,8.293,6.19,8.293l10.925,16.722l0.659,14.613l47.216,6.449l0.969,0.132 l5.003-1.579l0.921-4.08l-3.686-1.186l0.526-8.164l5.003-4.08c0,0,2.633-9.217,3.424-10.4 C210.191,241.076,220.594,238.971,215.722,235.811z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalifornia);
export default __webpack_public_path__ + "static/media/california.fba295fdd2445e1e73575dc92f413605.svg";
export { ForwardRef as ReactComponent };